







































export default
	props: nav: Array

	data: ->
		activeChildPane: ''

	methods:

		# close it
		reset: ->
			@$emit('reset')

		# show child pane
		showPane: (pane) ->
			@activeChildPane = pane

		# close the child pane
		closeChildPane: ->
			@activeChildPane = ''

	watch:

		# Close the nav when the route changes
		$route: ->
			@activeChildPane = ''

